import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

import { getDepartments } from "../services/departmentService";

const DepartmentsContext = createContext({
  departments: [],
  loading: true,
  error: "",
  refreshDepartments: async () => {},
});

// Shared cache for GET api/departments/ so pages/forms that need the department
// list (Departments page, Employee form dropdown, etc.) don't each fetch it separately.
export function DepartmentsProvider({ children }) {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refreshDepartments = useCallback(async () => {
    try {
      setLoading(true);
      setError("");

      const data = await getDepartments();
      setDepartments(data);
    } catch (requestError) {
      console.error("Department Fetch Error:", requestError);
      setError("Unable to fetch departments");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshDepartments();
  }, [refreshDepartments]);

  const value = useMemo(
    () => ({ departments, loading, error, refreshDepartments }),
    [departments, loading, error, refreshDepartments]
  );

  return (
    <DepartmentsContext.Provider value={value}>
      {children}
    </DepartmentsContext.Provider>
  );
}

export function useDepartments() {
  return useContext(DepartmentsContext);
}
